// Generated by GitHub Copilot
import { createFileRoute } from '@tanstack/react-router'
import { WorkOrderFormSettingsPage } from '#components/domain/operations/settings/work-order-form-settings-page.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'

export const Route = createFileRoute('/_appSettings/$companyId/settings/periodic-maintenances')({
  component: RouteComponent,
})

/** Settings page for Periodic Maintenances — the form-settings editor (PM reuses the work-order catalogs). */
function RouteComponent() {
  return (
    <WorkOrderFormSettingsPage
      entityType="periodic_maintenance"
      permissionService={PermissionService.PERIODIC_MAINTENANCES}
      titleKey="periodicMaintenancesSettings.title"
      descriptionKey="periodicMaintenancesSettings.description"
      noteKey="periodicMaintenancesSettings.note"
    />
  )
}
